import React, { useContext } from 'react';
import { ReactSVG } from 'react-svg';
import { FormattedMessage, useIntl } from 'react-intl';
import image from '../../../assets/image/welcome/slide1.svg';
import CustomBtn from '../../../generic/CustomBtn';
import { ContextForm } from '../../../utils/projectRegistration';

const StartOfRegistration = () => {
  const translate = useIntl();
  const { formData, setFormData } = useContext(ContextForm);

  return (
    <div className="project-register__startOfRegistration">
      <ReactSVG src={image} className="welcome__image" />
      <FormattedMessage
        id="project-register.title"
        values={{
          h2: (...chunks) => <h2 className="project-register__title">{chunks}</h2>,
        }}
      />
      <FormattedMessage
        id="project-register.subtitle"
        values={{
          p: (...chunks) => <p className="project-register__subtitle">{chunks}</p>,
          bold: (chunks) => <b>{chunks}</b>,
        }}
      />
      <ol className="project-register__list">
        <FormattedMessage
          id="project-register.paragraph1"
          values={{
            li: (...chunks) => <li className="project-register__item">{chunks}</li>,
          }}
        />
        <FormattedMessage
          id="project-register.paragraph2"
          values={{
            li: (...chunks) => <li className="project-register__item">{chunks}</li>,
          }}
        />
        <FormattedMessage
          id="project-register.paragraph3"
          values={{
            li: (...chunks) => <li className="project-register__item">{chunks}</li>,
          }}
        />
        <FormattedMessage
          id="project-register.paragraph4"
          values={{
            li: (...chunks) => <li className="project-register__item">{chunks}</li>,
          }}
        />
      </ol>
      <CustomBtn
        label={translate.formatMessage({ id: 'project-register.button' })}
        type="button"
        customClass="project-register__btn"
        handleClick={() => setFormData({ ...formData, activeProjectStep: formData.activeProjectStep + 1 })}
      />
    </div>
  );
};

export default StartOfRegistration;
